import React from 'react';
import styled from 'styled-components';
import dayjs from 'dayjs';

const FilterBarWrapper = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  margin-bottom: 14px;
  flex-wrap: wrap;
`;

const FilterChip = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  background: #2a2a2a;
  border: 1px solid #3a3a3a;
  border-radius: 6px;
  padding: 5px 12px;
  color: #e0e0e0;
  font-size: 13px;
  cursor: pointer;
  user-select: none;
  transition: background 0.2s;
  position: relative;

  &:hover {
    background: #333;
  }

  .label {
    color: #9a9a9a;
  }
  .value {
    color: #BA955E;
    font-weight: 600;
  }
  .arrow {
    color: #9a9a9a;
    font-size: 10px;
    margin-left: 2px;
  }

  select {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
    appearance: none;
    background: #222;
    color: #e0e0e0;
    color-scheme: dark;
    border: none;
    outline: none;

    option {
      background: #222;
      color: #e0e0e0;
    }
  }
`;

const FilterBar = ({ regions = [], filters, onFilterChange }) => {
  const dateRanges = [
    { id: '30d', label: 'Últimos 30 días', days: 30, unit: 'days' },
    { id: '3m', label: 'Últimos 3 meses', days: 3, unit: 'months' },
    { id: '6m', label: 'Últimos 6 meses', days: 6, unit: 'months' },
    { id: '12m', label: 'Último 12 meses', days: 12, unit: 'months' },
  ];

  const userTypes = [
    { id: 'ALL', label: 'Todos' },
    { id: 'FREE', label: 'Gratis' },
    { id: 'PAID', label: 'De Pago' },
  ];

  // Identificar el rango actual basado en la diferencia de fechas (simplificado)
  const getCurrentRangeId = () => {
    const start = dayjs(filters.startDate);
    const end = dayjs(filters.endDate);
    const diffMonths = end.diff(start, 'months');
    const diffDays = end.diff(start, 'days');

    if (diffDays <= 31) return '30d';
    if (diffMonths <= 3) return '3m';
    if (diffMonths <= 6) return '6m';
    return '12m';
  };

  const currentRangeId = getCurrentRangeId();

  const handleRegionChange = (e) => {
    const regionId = parseInt(e.target.value);
    // Si es 0, enviamos array vacío (Todo México)
    const zones = regionId === 0 ? [] : [regionId.toString()];
    onFilterChange({ zones });
  };

  const handleRangeChange = (e) => {
    const rangeId = e.target.value;
    const range = dateRanges.find(r => r.id === rangeId);
    if (range) {
      const startDate = dayjs().subtract(range.days, range.unit).startOf('day').toISOString();
      const endDate = dayjs().endOf('day').toISOString();
      onFilterChange({ startDate, endDate });
    }
  };

  const handleUserTypeChange = (e) => {
    onFilterChange({ userType: e.target.value });
  };

  const currentRegionId = filters.zones.length > 0 ? parseInt(filters.zones[0]) : 0;
  const currentRegionLabel = regions.find(r => r.id === currentRegionId)?.description || "Todo México";
  const currentRangeLabel = dateRanges.find(r => r.id === currentRangeId)?.label || "Últimos 30 días";
  const currentUserTypeLabel = userTypes.find(t => t.id === filters.userType)?.label || "Todos";

  return (
    <FilterBarWrapper>
      <FilterChip>
        <i className="fa-solid fa-bars-filter" style={{ color: '#9a9a9a', fontSize: 12 }} />
        <span className="label">Filtro:</span>
        <span className="value">{currentRegionLabel}</span>
        <span className="arrow">▼</span>
        <select value={currentRegionId} onChange={handleRegionChange}>
          <option value={0}>Todo México</option>
          {regions.filter(r => r.id !== 0).map(region => (
            <option key={region.id} value={region.id}>
              {region.description}
            </option>
          ))}
        </select>
      </FilterChip>

      <FilterChip>
        <i className="fa-regular fa-calendar" style={{ color: '#9a9a9a', fontSize: 12 }} />
        <span className="value">{currentRangeLabel}</span>
        <span className="arrow">▼</span>
        <select value={currentRangeId} onChange={handleRangeChange}>
          {dateRanges.map(range => (
            <option key={range.id} value={range.id}>
              {range.label}
            </option>
          ))}
        </select>
      </FilterChip>

      <FilterChip>
        <i className="fa-regular fa-user" style={{ color: '#9a9a9a', fontSize: 12 }} />
        <span className="label">Tipo de Usuario:</span>
        <span className="value">{currentUserTypeLabel}</span>
        <span className="arrow">▼</span>
        <select value={filters.userType} onChange={handleUserTypeChange}>
          {userTypes.map(type => (
            <option key={type.id} value={type.id}>
              {type.label}
            </option>
          ))}
        </select>
      </FilterChip>
    </FilterBarWrapper>
  );
};

export default FilterBar;
